module.exports = __webpack_public_path__ + "static/media/text-align-right-black.dd6fa18c.svg";